import { Routes, Route } from "react-router-dom";
import StoreAccessQuery from "@/pages/financial/store-access-query";

export default function StoreAccessQueryRoutes() {
  return (
    <Routes>
      <Route path="/" element={<StoreAccessQuery />} />
    </Routes>
  );
}
